import { useQuery } from '@apollo/client'

import { COUNTRIES, Countries } from './api'

export const useCountries = () => {
  const { data, loading } = useQuery<Countries>(COUNTRIES)

  return { countries: data?.countries.results, loading }
}
